import type {Part} from 'schemaDefinition/types';
import {DefaultPartCompare} from 'schemaDefinition/types';
import type {PartDiffProps} from '../components/types';

export const needsUpdatedSubValueContainer = (
  part: Part,
  diff: PartDiffProps,
): boolean => {
  return (
    diff &&
    diff.mode === 'updated' &&
    (part.compare ?? diff.outerCompare ?? DefaultPartCompare) === 'subValues'
  );
};
